// src/contexts/StudentContext.jsx
import React, { createContext, useContext } from 'react';
import { useStudents } from '../hooks/useStudents';

const StudentContext = createContext(null);

/**
 * Student Context Provider
 * Provides real-time student data to entire app
 */
export const StudentProvider = ({ children }) => {
  const students = useStudents();

  return (
    <StudentContext.Provider value={students}>
      {children}
    </StudentContext.Provider>
  );
};

/**
 * Custom hook to use student context
 */
export const useStudentContext = () => {
  const context = useContext(StudentContext);
  if (!context) {
    throw new Error('useStudentContext must be used within StudentProvider');
  }
  return context;
};

export default StudentContext;